// extracted by mini-css-extract-plugin
export default {"productGallery":"nH-z","inQuickShop":"oH-z"};